<template>
  <div :class="{overflow_hidden:popFail}" class="groupBook b_white">
    <template v-if="isEmpty">
      <div class="group_yhq">
        <img v-lazy="`${activityDtl.coverImage}?imageMogr2/thumbnail/120000@`">
      </div>
      <div class="group_me group_item">
        <p class="group_head mar13_b">{{ activity.title }}</p>
        <p class="f14_rem lin_15 gray_3 mar13_b">剩余{{ activityGoods.remainGoodsQuantity }}份</p>
        <p class="group_head mar13_b">活动时间</p>
        <p class="f14_rem lin_15 gray_3">
          {{ activity.startTimeStr }}
          —
          {{ activity.endTimeStr}}
        </p>
      </div>
      <div class="group_item">
        <p class="group_head mar15_b">拼团流程</p>
        <ul class="group_step clear">
          <li>
            <img src="../images/group_step1.png" alt="">
            <p>开团/参团</p>
          </li>
          <li>
            <img src="../images/group_step2.png" alt="">
            <p>分享好友</p>
            <p>邀请参团</p>
          </li>
          <li>
            <img src="../images/group_step3.png" alt="">
            <p>达到目标</p>
            <p>人数</p>
          </li>
          <li>
            <img src="../images/group_step4.png" alt="">
            <p>拼团成功</p>
            <p>等待收货</p>
          </li>
        </ul>
      </div>
      <div class="group_item group_plan_me group_plan_item relative">
        <p class="group_head mar5_b">我的拼团</p>
        <div class="group_plan_success" v-if="myInHandGroup.groupStatus == '2'">
          <img src="../images/group_plan_success.png" alt="">
        </div>
        <ul class="clear flex flex_wrap" v-if="myInHandGroup && myInHandGroup.id">
          <li>
            <div class="relative group_plan_img">
              <span class="group_plan_name">团长</span>
              <img :src="myInHandGroup.imgUrl" alt="">
            </div>
            <p class="f20_rem mui-ellipsis gray_3">{{ myInHandGroup.name }}</p>
          </li>
          <template v-if="myInHandGroup.groupDetailVoList && myInHandGroup.groupDetailVoList.length > 0">
            <li v-for="(detail, index) in myInHandGroup.groupDetailVoList" :key="index">
              <div class="relative group_plan_img">
                <img v-lazy="`${detail.imgUrl}?imageMogr2/thumbnail/120000@`">
              </div>
              <p class="f20_rem mui-ellipsis gray_3">{{ detail.name }}</p>
            </li>
          </template>
          <template v-if="myInHandGroup.remainPeople > 0">
            <li v-for="(index) in myInHandGroup.remainPeople" :key="index" @click="toShare">
              <img class="group_invite_icon" src="../images/group_invite_icon.png" alt="">
              <div class="relative group_plan_img">
                <img src="../images/group_invite.png" alt="">
              </div>
              <p class="f20_rem mui-ellipsis gray_3">拼团</p>
            </li>
          </template>
        </ul>
      </div>
      <div class="group_item group_good">
        <p class="group_head mar20_b">商品详情</p>
        <ul>
          <li class="clear" @click="toGoodsDetail(goodsEntity.goodsId)">
            <div class="collect_img relative mui-pull-left">
              <img v-lazy="`${goodsEntity.picUrl}?imageMogr2/thumbnail/120000@`">
            </div>
            <div class="mui-media-body mui-pull-left collect_main">
              <h3 class="f13_rem yahei gray_3 lin_15 mui-ellipsis-2 ">{{ goodsEntity.name }}</h3>
              <div class="box10"></div>
              <p class="red f14_rem fb">拼团价：¥ {{ activityGoods.goodsPrice }}</p>
              <div class="box5"></div>
              <p class="lin_15 f10_rem gray_6">原价：¥ {{ activityGoods.marketPrice }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="group_item group_desc" v-if="activityDtl.description">
        <p class="group_head mar20_b">活动规则</p>
        <div v-html="activityDtl.description"> </div>
      </div>
      <div class="group_item flex_center direction_column group_join_info">
        <img :src="myInHandGroup.imgUrl" alt="">
        <p class="c_fc472e max_w50 ellipsis inlineblock">{{ myInHandGroup.name }}</p>
        <p class="f12_rem gray_3">
          <span class="ellipsis inlineblock">发起拼团，支付完成后即可参团</span>
        </p>
      </div>
      <!--v-if="isShowBtn"-->
      <div class="box30" v-if="isIos"></div>
      <div class="box70" v-if="isShowBtn"></div>
      <div class="group_btn mar20_t">
        <p class="t_center f14_rem white btn_pay" v-if="isShowBtn" @click="toOrderSubmit">支付参团¥ {{ activityGoods.goodsPrice }}</p>
      </div>
<!--      <div class="group_btn mar20_t" v-if="isShowSponsorBtn && !isShowBtn">
        <p class="t_center f14_rem white btn_join" @click="toSponsorOrderSubmit">我要开团¥ {{ activityGoods.sponsorPrice }}</p>
      </div>-->
    </template>

    <div class="mask_block" v-if="popFail"></div>
    <div class="group_pop" v-show="popFail">
      <div class="group_success t_center">
        <div class="box50 flex justify_end align_center direction_column">
          <p class="f16_rem gray_3 lin_24" v-html="verifyResult.msg"></p>
        </div>
        <div class="box20"></div>
        <div class="group_pop_btn white pop_btn_success f16_rem"
             v-if="'401100,401106'.indexOf(verifyResult.code) !== -1" @click="toGoodList">去开团</div>
        <div class="group_pop_btn white pop_btn_success f16_rem"
             v-else-if="'401101'.indexOf(verifyResult.code) !== -1" @click="toGoodList">好的，去开团</div>
        <div class="group_pop_btn white pop_btn_success f16_rem"
             v-else @click="popFailClose">好的</div>
      </div>
    </div>
    <div class="share_mask" v-show="isShowShare" @click="isClose">
      <img src="../images/share.png" alt="">
    </div>
    <div class="group_me_float" @click="toMyGroup">
      <img src="../images/group_me.png" alt="">
      <span>我的拼团</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .group_desc ::v-deep img {
    display: block;
    width: 100%;
  }
  @import './style.scss';
</style>

<script>
import { mapState } from "vuex";
import common from "../../../assets/js/common";

export default {
  name: "groupBook",
  data() {
    return {
      popFail: false,
      activity: {},
      activityDtl: {},
      activityGoods: {},
      myInHandGroup: {},
      goodsEntity: {},
      isEmpty: false,
      isShowShare: false,
      isShowBtn: false,
      isShowSponsorBtn: false,
      verifyResult: {},
      shopId: "",
      shareBoId: "",
      isIos: false
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      this.isIos = true;
    }
    const { query } = this.$route;
    if (query.shopId) {
      this.shopId = query.shopId;
    }
    if (query.shareBoId) {
      this.shareBoId = query.shareBoId;
    }
    this.verifyGroupStatus();
  },
  methods: {
    verifyGroupStatus() {
      this.$store.dispatch("group/goods/getVerifyGroupStatus", {
        activityId: this.$route.query.activityId
      }).then((res) => {
        this.verifyResult = res;
        if (res.code === "0") {
          this.isEmpty = true;
          this.load();
          this.getMyInHandGroupList();
        } else {
          $(".mask").show();
          this.popFail = true;
          this.isEmpty = false;
        }
      });
    },
    popFailClose() {
      $(".mask").hide();
      this.popFail = false;
    },
    toMyGroup() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      this.$router.push(`/group/myGroup?shopId=${this.shopId}`);
    },
    isClose() {
      this.isShowShare = false;
    },
    toGoodList() {
      this.$router.push("/group/goodList");
    },
    toShare() {
      this.isShowShare = true;
    },
    initData() {
      const shareImgUrl = `${this.activityDtl.shareImage}`;
      let param = `?shopId=${this.shopId}&goodsId=${this.$route.query.goodsId}&activityId=${this.$route.query.activityId}&groupId=${this.$route.query.groupId}`;
      if (this.shareBoId) {
        param = `?shareBoId=${this.shareBoId}&shopId=${this.shopId}&goodsId=${this.$route.query.goodsId}&activityId=${this.$route.query.activityId}&groupId=${this.$route.query.groupId}`;
      }
      const urlShare = `${process.env.VUE_APP_APP}vm/group/shareGroupBook${param}`;
      const titleShare = `${this.activity.title}`;
      const descShare = "快来和我一起拼团吧";
      if (common.isInWeiXin()) {
        common.initShare(titleShare, descShare, urlShare, shareImgUrl);
      }
    },
    load() {
      this.$store.dispatch("group/goods/queryGroupDetail", {
        goodsId: this.$route.query.goodsId,
        activityId: this.$route.query.activityId,
        groupId: this.$route.query.groupId,
        shareBoId: this.shareBoId
      }).then((res) => {
        if (res.data) {
          this.activity = res.data.activity;
          document.title = this.activity.title;
          this.activityDtl = res.data.activityDtl;
          this.activityGoods = res.data.activityGoods;
          this.goodsEntity = this.activityGoods.goodsEntity;
          this.initData();
        }
      });
    },
    getMyInHandGroupList() {
      this.$store.dispatch("group/goods/getMyInHandGroupList", {
        groupId: this.$route.query.groupId
      }).then((res) => {
        this.myInHandGroup = res.data || {};
        // 团长
        if (this.myInHandGroup.sponsorBoId && this.myInHandGroup.sponsorBoId === this.userInfo.id) {
          this.isShowBtn = false;
          return;
        }
        // 团员
        if (this.myInHandGroup.groupDetailVoList) {
          const find = this.myInHandGroup.groupDetailVoList.find(value => value.boId === this.userInfo.id);
          if (find) {
            this.isShowBtn = false;
            return;
          }
        }
        this.isShowBtn = true;
        /* if (this.myInHandGroup.groupStatus >= 2) {
          this.isShowSponsorBtn = true;
        } */
      });
    },
    // 参团
    toOrderSubmit() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      this.$store.dispatch("group/goods/getVerifyJoinGroup", {
        groupId: this.$route.query.groupId
      }).then((res) => {
        this.verifyResult = res;
        if (res.code === "0") {
          const orderCartEntity = [{
            goodsId: this.activityGoods.goodsId,
            goodsQuantity: 1,
            fromShopId: this.activity.shopId,
            fundShopId: this.activity.shopId,
            fromCart: 0,
            isYxGroup: 1,
            yxGroupId: this.$route.query.groupId
          }];
          const goodsInJson = JSON.stringify(orderCartEntity);
          const carts = encodeURIComponent(goodsInJson);
          window.location.href = `${process.env.VUE_APP_APP}mob/order/confirmOrder.do?sources=0&carts=${carts}`;
          return;
        }
        if (res.code === "401105") {
          // 跳转订单详情
          this.toOrderDetail(res.data.orderId);
        } else {
          // 失败
          $(".mask").show();
          this.popFail = true;
        }
      });
    },
    // 开团
    toSponsorOrderSubmit() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      this.$store.dispatch("group/goods/getVerifySponsorGroup", {
        goodsId: this.activityGoods.goodsId
      }).then((res) => {
        this.verifyResult = res;
        if (res.code === "0") {
          const orderCartEntity = [{
            goodsId: this.activityGoods.goodsId,
            goodsQuantity: 1,
            fromShopId: this.activity.shopId,
            fundShopId: this.activity.shopId,
            fromCart: 0,
            isYxGroup: 1,
            yxGroupId: ""
          }];
          const goodsInJson = JSON.stringify(orderCartEntity);
          const carts = encodeURIComponent(goodsInJson);
          window.location.href = `${process.env.VUE_APP_APP}mob/order/confirmOrder.do?sources=0&carts=${carts}`;
          return;
        }
        if (res.code === "401108") {
          // 跳转订单详情
          this.toOrderDetail(res.data.orderId);
        } else {
          // 失败
          $(".mask").show();
          this.popFail = true;
        }
      });
    },
    toOrderDetail(orderId) {
      window.location.href = `${process.env.VUE_APP_APP}mob/order/person/orderDetail.do?orderId=${orderId}`;
    },
    toGoodsDetail(goodsId) {
      window.location.href = `/vm/goodDetails/${goodsId}`;
    }
  }
};
</script>
